import { sanitizeMerchantRedirectUrl } from './merchantRedirectUrl';

export const getRedirectLinkFromUrlParams = () => {
  const searchParams = new URLSearchParams(window.location.search);
  return sanitizeMerchantRedirectUrl(searchParams.get('redirectUrl')) ?? '';
};
